import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'High-Priority Stakeholders — High Impact + High Influence',
      type: 'table',
      alias: 'high-priority-stakeholders-table',
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'records',
                },
              },
              subqueries: {
                records: {
                  filter: {
                    and: [
                      {
                        '=': [
                          {
                            '@.': '!degree_of_impact',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!influence_decision_role',
                          },
                          'High',
                        ],
                      },
                    ],
                  },
                  target: 'ent:!stakeholders:!stakeholder',
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                by: {
                  '@.': '!name',
                },
                descending: false,
              },
              filter: {
                and: [
                  {
                    '=': [
                      {
                        '@.': '!degree_of_impact',
                      },
                      'High',
                    ],
                  },
                  {
                    '=': [
                      {
                        '@.': '!influence_decision_role',
                      },
                      'High',
                    ],
                  },
                ],
              },
              target: 'ent:!stakeholders:!stakeholder',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      jobTitleRole: {
                        '{}': {
                          value: {
                            '@': 'jobTitle',
                          },
                        },
                      },
                      changeChampion: {
                        '{}': {
                          value: {
                            '@.': '!change_champion',
                          },
                        },
                      },
                      degreeOfImpact: {
                        '{}': {
                          color: '#3AA69B',
                          value: {
                            '@.': '!degree_of_impact',
                          },
                        },
                      },
                      stakeholderName: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      engagementNeeded: {
                        '{}': {
                          value: {
                            '@.': '!engagement_needed',
                          },
                        },
                      },
                      departmentFunction: {
                        '{}': {
                          value: {
                            '@': 'department',
                          },
                        },
                      },
                      influenceDecisionRole: {
                        '{}': {
                          color: '#3AA69B',
                          value: {
                            '@.': '!influence_decision_role',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                employee: {
                  ref: {
                    attr: 'attr:ent#!stakeholders#!stakeholder:!employee',
                  },
                  target: 'ent:!personnel:!employee',
                },
                jobTitle: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!job_title',
                  },
                  using: 'employee',
                  target: 'ent:!job_titles:!job_title',
                  quantity: 1,
                  selection: {
                    '@.': '!name',
                  },
                },
                department: {
                  ref: {
                    attr: 'attr:ent#!personnel#!employee:!org',
                  },
                  using: 'employee',
                  target: 'ent:!org:!subdept',
                  quantity: 1,
                  selection: {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-advancement',
                          ],
                        },
                        'Advancement',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-athletics',
                          ],
                        },
                        'Athletics',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-finance-and-treasury',
                          ],
                        },
                        'Finance and Treasury',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-information-technology',
                          ],
                        },
                        'Information Technology',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-undergraduate-financial-aid',
                          ],
                        },
                        'Undergraduate Financial Aid',
                      ],
                      [
                        {
                          '=': [
                            {
                              '@^': 'parent',
                            },
                            '?dept-school-of-engineering-and-applied-science',
                          ],
                        },
                        'School of Engineering and Applied Science',
                      ],
                      null,
                    ],
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'stakeholderName',
                  direct: {
                    '{}': {
                      name: 'Stakeholder Name',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'jobTitleRole',
                  direct: {
                    '{}': {
                      name: 'Job Title / Role',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'departmentFunction',
                  direct: {
                    '{}': {
                      name: 'Department / Function',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'degreeOfImpact',
                  direct: {
                    '{}': {
                      name: 'Degree of Impact',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'influenceDecisionRole',
                  direct: {
                    '{}': {
                      name: 'Influence / Decision Role',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'engagementNeeded',
                  direct: {
                    '{}': {
                      name: 'Engagement Needed',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_engagement_needed',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'changeChampion',
                  direct: {
                    '{}': {
                      name: 'Change Champion',
                      type: {
                        '{}': {
                          enumId: 'enum::!stakeholder_change_champion',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
